export const isNumeric = (e) => {
  const reg = /^[0-9\b]+$/
  const keyCode = e.keyCode || e.which
  const keyValue = String.fromCharCode(keyCode)
  if (!reg.test(keyValue)) e.preventDefault()
}

export const numberWithCommas = (x, digit) => {
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: digit,
    minimumFractionDigits: digit
  }).format(Number(x))
}



// WEBPACK FOOTER //
// ./src/utils/number.js